(() => {
  const SELECTOR = '[data-shipping-estimate]';

  const WAREHOUSE_TIMEZONE = 'Europe/Stockholm';

  const CUTOFF_HOUR = 14;
  const CUTOFF_MINUTE = 0;


  /**
   * ---------------------------------------------------------------------------
   * MARKET CONFIGURATION
   * ---------------------------------------------------------------------------
   */

  const MARKET_CONFIG = {
    AT: {
      carrier: 'ÖPAG',
      logo: 'opag',
      transitDays: 3,
      saturdayDelivery: true
    },

    BE: {
      carrier: 'Bpost',
      logo: 'bpost',
      transitDays: 2,
      saturdayDelivery: true
    },

    CZ: {
      carrier: 'PPL CZ',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    DE: {
      carrier: 'DHL',
      logo: 'dhl',
      transitDays: 2,
      saturdayDelivery: true
    },

    EE: {
      carrier: 'SmartPosti',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    LV: {
      carrier: 'SmartPosti',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    LT: {
      carrier: 'SmartPosti',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    DK: {
      carrier: 'GLS',
      logo: 'gls',
      transitDays: 1,
      saturdayDelivery: false
    },

    ES: {
      carrier: 'DHL',
      logo: null,
      transitDays: 4,
      saturdayDelivery: false
    },

    FI: {
      carrier: 'Posti',
      logo: 'posti',
      transitDays: 2,
      saturdayDelivery: false
    },

    SE: {
      carrier: 'PostNord',
      logo: 'postnord',
      transitDays: 1,
      saturdayDelivery: false
    },

    FR: {
      carrier: 'Colis Privé',
      logo: null,
      transitDays: 3,
      saturdayDelivery: true
    },

    IT: {
      carrier: 'Poste Italiane',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    NL: {
      carrier: 'DHL',
      logo: null,
      transitDays: 2,
      saturdayDelivery: true
    },

    US: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    CA: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    NO: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    PL: {
      carrier: 'DHL',
      logo: null,
      transitDays: 2,
      saturdayDelivery: false
    },

    CH: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    GB: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 3,
      saturdayDelivery: false
    },

    AU: {
      carrier: 'FedEx',
      logo: null,
      transitDays: 5,
      saturdayDelivery: false
    }
  };


  /**
   * ---------------------------------------------------------------------------
   * TRANSLATIONS
   * ---------------------------------------------------------------------------
   */

  const TRANSLATIONS = {
    en: {
      shipped: 'Shipped:',
      estimated_delivery: 'Estimated delivery:',
      today: 'Today',
      tomorrow: 'Tomorrow',
      order_within: 'Order within',
      hours: 'hours',
      minutes: 'minutes',
      seconds: 'seconds'
    },

    da: {
      shipped: 'Sendes:',
      estimated_delivery: 'Forventet levering:',
      today: 'I dag',
      tomorrow: 'I morgen',
      order_within: 'Bestil inden',
      hours: 'timer',
      minutes: 'minutter',
      seconds: 'sekunder'
    },

    de: {
      shipped: 'Versendet:',
      estimated_delivery: 'Lieferung:',
      today: 'Heute',
      tomorrow: 'Morgen',
      order_within: 'Bestelle innerhalb von',
      hours: 'Stunden',
      minutes: 'Minuten',
      seconds: 'Sekunden'
    },

    es: {
      shipped: 'Enviado:',
      estimated_delivery: 'Entrega estimada:',
      today: 'Hoy',
      tomorrow: 'Mañana',
      order_within: 'Haz tu pedido en',
      hours: 'horas',
      minutes: 'minutos',
      seconds: 'segundos'
    },

    fi: {
      shipped: 'Lähetetään:',
      estimated_delivery: 'Arvioitu toimitus:',
      today: 'Tänään',
      tomorrow: 'Huomenna',
      order_within: 'Tilaa',
      hours: 'tuntia',
      minutes: 'minuuttia',
      seconds: 'sekuntia'
    },

    fr: {
      shipped: 'Expédié :',
      estimated_delivery: 'Livraison estimée:',
      today: 'Aujourd’hui',
      tomorrow: 'Demain',
      order_within: 'Commandez dans les',
      hours: 'heures',
      minutes: 'minutes',
      seconds: 'secondes'
    },

    it: {
      shipped: 'Spedito:',
      estimated_delivery: 'Consegna stimata:',
      today: 'Oggi',
      tomorrow: 'Domani',
      order_within: 'Ordina entro',
      hours: 'ore',
      minutes: 'minuti',
      seconds: 'secondi'
    },

    nl: {
      shipped: 'Verzonden:',
      estimated_delivery: 'Geschatte levering:',
      today: 'Vandaag',
      tomorrow: 'Morgen',
      order_within: 'Bestel binnen',
      hours: 'uur',
      minutes: 'minuten',
      seconds: 'seconden'
    },

    no: {
      shipped: 'Sendes:',
      estimated_delivery: 'Forventet levering:',
      today: 'I dag',
      tomorrow: 'I morgen',
      order_within: 'Bestill innen',
      hours: 'timer',
      minutes: 'minutter',
      seconds: 'sekunder'
    },

    pl: {
      shipped: 'Wysłano:',
      estimated_delivery: 'Przewidywana dostawa:',
      today: 'Dzisiaj',
      tomorrow: 'Jutro',
      order_within: 'Zamów w ciągu',
      hours: 'godzin',
      minutes: 'minut',
      seconds: 'sekund'
    },

    sv: {
      shipped: 'Skickas:',
      estimated_delivery: 'Beräknad leverans:',
      today: 'Idag',
      tomorrow: 'I morgon',
      order_within: 'Beställ inom',
      hours: 'timmar',
      minutes: 'minuter',
      seconds: 'sekunder'
    }
  };


  /**
   * ---------------------------------------------------------------------------
   * BASIC DATE HELPERS
   * ---------------------------------------------------------------------------
   */

  function createCalendarDate(year, month, day) {
    return new Date(
      Date.UTC(year, month - 1, day, 12, 0, 0)
    );
  }


  function cloneDate(date) {
    return new Date(date.getTime());
  }


  function addCalendarDays(date, amount) {
    const result = cloneDate(date);

    result.setUTCDate(
      result.getUTCDate() + amount
    );

    return result;
  }


  function getDateKey(date) {
    return [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0')
    ].join('-');
  }


  /**
   * ---------------------------------------------------------------------------
   * STOCKHOLM TIME
   * ---------------------------------------------------------------------------
   */

  function getStockholmNow() {
    const formatter = new Intl.DateTimeFormat(
      'en-GB',
      {
        timeZone: WAREHOUSE_TIMEZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      }
    );

    const parts = formatter.formatToParts(new Date());
    const values = {};

    parts.forEach((part) => {
      if (part.type === 'literal') return;

      values[part.type] = Number(part.value);
    });

    return values;
  }


  function getStockholmCalendarDate() {
    const now = getStockholmNow();

    return createCalendarDate(
      now.year,
      now.month,
      now.day
    );
  }


  /**
   * ---------------------------------------------------------------------------
   * WAREHOUSE DAYS
   * ---------------------------------------------------------------------------
   */

  function isWarehouseOpen(date) {
    const weekday = date.getUTCDay();

    return weekday >= 1 && weekday <= 5;
  }


  function getNextWarehouseDay(date) {
    let candidate = addCalendarDays(date, 1);

    while (!isWarehouseOpen(candidate)) {
      candidate = addCalendarDays(candidate, 1);
    }

    return candidate;
  }


  /**
   * ---------------------------------------------------------------------------
   * DISPATCH
   * ---------------------------------------------------------------------------
   */

  function calculateDispatch() {
    const now = getStockholmNow();

    const today = createCalendarDate(
      now.year,
      now.month,
      now.day
    );

    const currentMinutes =
      now.hour * 60 + now.minute;

    const cutoffMinutes =
      CUTOFF_HOUR * 60 + CUTOFF_MINUTE;

    const beforeCutoff =
      currentMinutes < cutoffMinutes;

    if (isWarehouseOpen(today) && beforeCutoff) {
      return {
        date: today,
        shipsToday: true,
        stockholmNow: now
      };
    }

    if (isWarehouseOpen(today)) {
      return {
        date: getNextWarehouseDay(today),
        shipsToday: false,
        stockholmNow: now
      };
    }

    let candidate = cloneDate(today);

    do {
      candidate = addCalendarDays(candidate, 1);
    } while (!isWarehouseOpen(candidate));

    return {
      date: candidate,
      shipsToday: false,
      stockholmNow: now
    };
  }


  /**
   * ---------------------------------------------------------------------------
   * DELIVERY DAYS
   * ---------------------------------------------------------------------------
   */

  function isDeliveryDay(date, market) {
    const weekday = date.getUTCDay();

    if (weekday === 0) {
      return false;
    }

    if (weekday === 6) {
      return market.saturdayDelivery === true;
    }

    return true;
  }


  function calculateDeliveryDate(dispatchDate, market) {
    let date = cloneDate(dispatchDate);
    let countedDays = 0;

    while (countedDays < market.transitDays) {
      date = addCalendarDays(date, 1);

      if (isDeliveryDay(date, market)) {
        countedDays++;
      }
    }

    return date;
  }


  /**
   * ---------------------------------------------------------------------------
   * LANGUAGE
   * ---------------------------------------------------------------------------
   */

  function getLanguage(element) {
    const locale =
      element.dataset.locale ||
      document.documentElement.lang ||
      'en';

    const language = locale.toLowerCase().split('-')[0];

    return TRANSLATIONS[language] ? language : 'en';
  }


  function getTranslation(element, key) {
    const language = getLanguage(element);

    return TRANSLATIONS[language][key] || '';
  }


  /**
   * ---------------------------------------------------------------------------
   * DATE DISPLAY
   * ---------------------------------------------------------------------------
   */

  function formatDate(date, element) {
    const today = getStockholmCalendarDate();
    const tomorrow = addCalendarDays(today, 1);

    if (getDateKey(date) === getDateKey(today)) {
      return getTranslation(element, 'today');
    }

    if (getDateKey(date) === getDateKey(tomorrow)) {
      return getTranslation(element, 'tomorrow');
    }

    const locale =
      element.dataset.locale ||
      document.documentElement.lang ||
      'en';

    const formattedDate = new Intl.DateTimeFormat(
      locale,
      {
        weekday: 'long',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC'
      }
    ).format(date);

    return (
      formattedDate.charAt(0).toLocaleUpperCase(locale) +
      formattedDate.slice(1)
    );
  }


  /**
   * ---------------------------------------------------------------------------
   * CARRIER LOGOS
   * ---------------------------------------------------------------------------
   */

  function getCarrierLogo(element, logo) {
    switch (logo) {
      case 'fedex':
        return element.dataset.logoFedex;

      case 'posteitaliane':
        return element.dataset.logoPosteitaliane;

      case 'colis-prive':
        return element.dataset.logoColisPrive;

      case 'gls':
        return element.dataset.logoGls;

      case 'smart-posti':
        return element.dataset.logoSmartPosti;

      case 'dhl':
        return element.dataset.logoDhl;

      case 'ppl-cz':
        return element.dataset.logoPplCz;

      case 'bpost':
        return element.dataset.logoBpost;

      case 'opag':
        return element.dataset.logoOpag;

      case 'posti':
        return element.dataset.logoPosti;

      case 'postnord':
        return element.dataset.logoPostnord;

      default:
        return '';
    }
  }


  /**
   * ---------------------------------------------------------------------------
   * VARIANT AVAILABILITY
   * ---------------------------------------------------------------------------
   *
   * Shopify variant availability is supplied
   * through JSON in shipping-estimate.liquid.
   *
   * The component only displays when the
   * currently selected variant is available.
   */

  function getVariantAvailability(element) {
    const sectionId = element.dataset.sectionId;

    const availabilityElement = document.getElementById(
      `shipping-availability-${sectionId}`
    );

    if (!availabilityElement) {
      return {};
    }

    try {
      return JSON.parse(availabilityElement.textContent);
    } catch (error) {
      console.error(
        'Shipping estimate: Invalid variant availability JSON',
        error
      );

      return {};
    }
  }


  function getSelectedVariantId(element) {
    const sectionId = element.dataset.sectionId;

    const form = document.getElementById(
      `product-form-${sectionId}`
    );

    const input = form?.querySelector('input[name="id"]');

    return (
      input?.value ||
      element.dataset.selectedVariant ||
      null
    );
  }


  function updateShippingVisibility(element, variantId) {
    const availability =
      element._shippingVariantAvailability || {};

    const selectedVariantId =
      variantId === undefined
        ? getSelectedVariantId(element)
        : variantId;

    const isAvailable =
      availability[String(selectedVariantId)] === true;

    element._shippingVariantAvailable = isAvailable;

    element.hidden = !isAvailable;
  }


  /**
   * ---------------------------------------------------------------------------
   * COUNTDOWN TARGET
   * ---------------------------------------------------------------------------
   */

  function getCountdownSeconds(dispatch) {
    const now = getStockholmNow();

    const currentTime = Date.UTC(
      now.year,
      now.month - 1,
      now.day,
      now.hour,
      now.minute,
      now.second
    );

    const targetTime = Date.UTC(
      dispatch.date.getUTCFullYear(),
      dispatch.date.getUTCMonth(),
      dispatch.date.getUTCDate(),
      CUTOFF_HOUR,
      CUTOFF_MINUTE,
      0
    );

    return Math.max(
      0,
      Math.floor((targetTime - currentTime) / 1000)
    );
  }


  /**
   * ---------------------------------------------------------------------------
   * COUNTDOWN UNIT
   * ---------------------------------------------------------------------------
   */

  function getCountdownTranslationKey(remainingSeconds) {
    if (remainingSeconds < 60) {
      return 'seconds';
    }

    if (remainingSeconds < 3600) {
      return 'minutes';
    }

    return 'hours';
  }


  /**
   * ---------------------------------------------------------------------------
   * COUNTDOWN DISPLAY
   * ---------------------------------------------------------------------------
   */

  function updateCountdown(element, state) {
    const output = element.querySelector(
      '[data-shipping-countdown-time]'
    );

    const countdownTextOutput = element.querySelector(
      '[data-shipping-time]'
    );

    if (!output) return;

    const remainingSeconds = getCountdownSeconds(
      state.dispatch
    );

    /*
     * At cutoff, recalculate the complete estimate.
     */
    if (remainingSeconds <= 0) {
      renderEstimate(element, state);
      return;
    }

    const hours = Math.floor(
      remainingSeconds / 3600
    );

    const minutes = Math.floor(
      (remainingSeconds % 3600) / 60
    );

    const seconds = remainingSeconds % 60;

    const formattedTime = [
      String(hours).padStart(2, '0'),
      String(minutes).padStart(2, '0'),
      String(seconds).padStart(2, '0')
    ].join(':');

    output.textContent = formattedTime;

    if (countdownTextOutput) {
      const translationKey = getCountdownTranslationKey(
        remainingSeconds
      );

      countdownTextOutput.textContent = getTranslation(
        element,
        translationKey
      );
    }
  }


  /**
   * ---------------------------------------------------------------------------
   * FULL RENDER
   * ---------------------------------------------------------------------------
   */

  function renderEstimate(element, existingState = null) {
    const country = (
      element.dataset.country || ''
    ).toUpperCase();

    const market = MARKET_CONFIG[country];

    /*
     * Market not configured:
     * remove component completely.
     */
    if (!market) {
      element.remove();
      return;
    }

    const dispatch = calculateDispatch();

    const deliveryDate = calculateDeliveryDate(
      dispatch.date,
      market
    );

    const state = existingState || {};

    state.market = market;
    state.dispatch = dispatch;
    state.deliveryDate = deliveryDate;


    /**
     * -------------------------------------------------------------------------
     * CARRIER LOGO
     * -------------------------------------------------------------------------
     */

    const carrierLogo = element.querySelector(
      '[data-shipping-carrier-logo]'
    );

    const carrierContainer = element.querySelector(
      '.shipping-estimate__carrier'
    );

    const shippingInfo = element.querySelector(
      '.shipping-estimate__info'
    );

    if (carrierLogo) {
      const logoUrl = getCarrierLogo(
        element,
        market.logo
      );

      if (logoUrl) {
        if (carrierLogo.getAttribute('src') !== logoUrl) {
          carrierLogo.src = logoUrl;
        }

        carrierLogo.alt = market.carrier;
        carrierLogo.hidden = false;

        if (carrierContainer) {
          carrierContainer.hidden = false;
        }

        if (shippingInfo) {
          shippingInfo.classList.remove(
            'shipping-estimate__info--centered'
          );
        }
      } else {
        carrierLogo.hidden = true;

        if (carrierContainer) {
          carrierContainer.hidden = true;
        }

        if (shippingInfo) {
          shippingInfo.classList.add(
            'shipping-estimate__info--centered'
          );
        }
      }
    }


    /**
     * -------------------------------------------------------------------------
     * COUNTDOWN TEXT
     * -------------------------------------------------------------------------
     */

    const orderWithinOutput = element.querySelector(
      '[data-shipping-order-within]'
    );

    if (orderWithinOutput) {
      orderWithinOutput.textContent = getTranslation(
        element,
        'order_within'
      );
    }


    /**
     * -------------------------------------------------------------------------
     * LABELS
     * -------------------------------------------------------------------------
     */

    const shippedLabel = element.querySelector(
      '[data-shipping-shipped-label]'
    );

    if (shippedLabel) {
      shippedLabel.textContent = getTranslation(
        element,
        'shipped'
      );
    }

    const estimatedDeliveryLabel = element.querySelector(
      '[data-shipping-estimated-delivery-label]'
    );

    if (estimatedDeliveryLabel) {
      estimatedDeliveryLabel.textContent = getTranslation(
        element,
        'estimated_delivery'
      );
    }


    /**
     * -------------------------------------------------------------------------
     * DISPATCH DATE
     * -------------------------------------------------------------------------
     */

    const dispatchOutput = element.querySelector(
      '[data-shipping-dispatch]'
    );

    if (dispatchOutput) {
      dispatchOutput.textContent = formatDate(
        dispatch.date,
        element
      );
    }


    /**
     * -------------------------------------------------------------------------
     * DELIVERY DATE
     * -------------------------------------------------------------------------
     */

    const deliveryOutput = element.querySelector(
      '[data-shipping-delivery]'
    );

    if (deliveryOutput) {
      deliveryOutput.textContent = formatDate(
        deliveryDate,
        element
      );
    }


    /**
     * -------------------------------------------------------------------------
     * COUNTDOWN
     * -------------------------------------------------------------------------
     */

    updateCountdown(element, state);


    /**
     * -------------------------------------------------------------------------
     * VISIBILITY
     * -------------------------------------------------------------------------
     *
     * Only reveal the component when:
     *
     * - Shipping information has been rendered.
     * - The selected variant is available.
     */

    updateShippingVisibility(element);

    return state;
  }


  /**
   * ---------------------------------------------------------------------------
   * INITIALIZE COMPONENT
   * ---------------------------------------------------------------------------
   */

  function initializeElement(element) {
    if (
      element.dataset.shippingEstimateInitialized === 'true'
    ) {
      return;
    }

    element.dataset.shippingEstimateInitialized = 'true';

    /*
     * Load variant availability data.
     */
    element._shippingVariantAvailability =
      getVariantAvailability(element);

    /*
     * Keep hidden until the component has rendered.
     */
    element.hidden = true;

    const state = renderEstimate(element);

    if (!state) return;

    /*
     * Countdown updates once every second.
     */
    const timer = window.setInterval(() => {
      updateCountdown(element, state);
    }, 1000);

    element._shippingEstimateTimer = timer;
  }


  /**
   * ---------------------------------------------------------------------------
   * INITIALIZE ALL
   * ---------------------------------------------------------------------------
   */

  function init() {
    document.querySelectorAll(SELECTOR).forEach(
      initializeElement
    );
  }


  /**
   * ---------------------------------------------------------------------------
   * VARIANT CHANGES
   * ---------------------------------------------------------------------------
   *
   * template-product.js updates the hidden
   * input[name="id"] when a variant changes.
   *
   * We also listen directly to variant pickers
   * to handle unavailable combinations.
   */

  document.addEventListener('change', (event) => {
    /*
     * Product form variant ID changes.
     */
    if (event.target.matches('input[name="id"]')) {
      const form = event.target.closest('form');

      if (form) {
        document.querySelectorAll(SELECTOR).forEach(
          (element) => {
            const sectionId = element.dataset.sectionId;

            if (form.id !== `product-form-${sectionId}`) {
              return;
            }

            updateShippingVisibility(
              element,
              event.target.value
            );
          }
        );
      }
    }

    /*
     * Variant picker changes.
     */
    const picker = event.target.closest(
      'variant-selects, variant-radios, variant-selects-remote'
    );

    if (!picker) return;

    requestAnimationFrame(() => {
      document.querySelectorAll(SELECTOR).forEach(
        (element) => {
          if (
            picker.dataset.section !==
            element.dataset.sectionId
          ) {
            return;
          }

          updateShippingVisibility(
            element,
            picker.currentVariant?.id || ''
          );
        }
      );
    });
  });


  /**
   * ---------------------------------------------------------------------------
   * PAGE LOAD
   * ---------------------------------------------------------------------------
   */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }


  /**
   * ---------------------------------------------------------------------------
   * SHOPIFY THEME EDITOR
   * ---------------------------------------------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      event.target
        .querySelectorAll(SELECTOR)
        .forEach(initializeElement);
    }
  );


  document.addEventListener(
    'shopify:section:unload',
    (event) => {
      event.target
        .querySelectorAll(SELECTOR)
        .forEach((element) => {
          if (element._shippingEstimateTimer) {
            window.clearInterval(
              element._shippingEstimateTimer
            );
          }
        });
    }
  );
})();